import { render, staticRenderFns } from "./SocialSignInButton.vue?vue&type=template&id=b0b2460e&scoped=true&"
import script from "./SocialSignInButton.vue?vue&type=script&lang=js&"
export * from "./SocialSignInButton.vue?vue&type=script&lang=js&"
import style0 from "./SocialSignInButton.vue?vue&type=style&index=0&id=b0b2460e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b2460e",
  null
  
)

export default component.exports